<template>
  <div>
    <div @click="dialog = true" style="cursor: pointer">
      <slot name="activator"> </slot>
      <div v-if="!hasActivatorSlot">
        <v-icon small color="primary" class="ml-1">
          mdi-information-outline
        </v-icon>
      </div>
    </div>
    <v-dialog v-model="dialog" width="500" scrollable>
      <v-card>
        <div class="d-flex flex-row">
          <div class="font-weight-bold mx-4 mt-2" v-if="title">{{ title }}</div>

          <v-spacer></v-spacer>

          <v-btn icon text @click="dialog = false">
            <v-icon color="primary">mdi-close</v-icon></v-btn
          >
        </div>
        <v-divider v-if="title" class="mb-2"></v-divider>
        <v-card-text class="darkerCardText">
          <slot name="content"></slot>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "SimplePopover",
  props: {
    title: null,
  },
  data: function () {
    return {
      dialog: false,
    };
  },
  methods: {},
  computed: {
    hasActivatorSlot() {
      return !!this.$slots.activator;
    },
  },
};
</script>

<style scoped></style>
